// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as OrderStatus from "../../../../../../library/data-source/order/entity/OrderStatus.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CancelOrderForm from "./CancelOrderForm.bs.js";
import * as Accordion$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/Accordion.bs.js";
import * as EditOrderDataMachine from "../../../app/repo/EditOrderDataMachine.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as OrderCancellationReasonsVm from "../../view-model/OrderCancellationReasonsVm.bs.js";
import * as EditOrderFareDetailsSection from "../fare-details/EditOrderFareDetailsSection.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function getPricingAccordian(crn) {
  return AccordionTypes$Catalyst.make_props({
              TAG: /* Text */0,
              _0: "Fare Details"
            }, undefined, undefined, React.createElement(EditOrderFareDetailsSection.make, {
                  crn: crn
                }), undefined);
}

function CancelOrderCmp(Props) {
  var toggleEditOrderSidebar = Props.toggleEditOrderSidebar;
  var changeDiscardModalState = Props.changeDiscardModalState;
  var order = Props.order;
  var openSnackbar = Props.openSnackbar;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var order$1 = order._0;
  var orderId = order$1.order_crn;
  var order_updated_at = order$1.order_updated_at;
  var orderStatus = order$1.status;
  var match$1 = React.useState(function () {
        return /* Init */0;
      });
  var setCancellationReasons = match$1[1];
  var cancellationReasons = match$1[0];
  React.useEffect((function () {
          Curry._1(setCancellationReasons, (function (param) {
                  return {
                          TAG: /* Loading */0,
                          _0: undefined
                        };
                }));
          EditOrderDataMachine.fetchOrderCancellationReasons(OrderStatus.toString(orderStatus), (function (data) {
                  return Curry._1(setCancellationReasons, (function (param) {
                                return {
                                        TAG: /* Live */1,
                                        _0: data
                                      };
                              }));
                }), (function (error) {
                  return Curry._1(setCancellationReasons, (function (param) {
                                return {
                                        TAG: /* Error */2,
                                        _0: error
                                      };
                              }));
                }), country);
          
        }), []);
  var tmp;
  if (typeof cancellationReasons === "number") {
    tmp = null;
  } else {
    switch (cancellationReasons.TAG | 0) {
      case /* Loading */0 :
          tmp = React.createElement(LoadingViewComponent$Catalyst.make, {});
          break;
      case /* Live */1 :
          tmp = React.createElement(CancelOrderForm.make, {
                cancellationReasons: OrderCancellationReasonsVm.execute(cancellationReasons._0),
                toggleEditOrderSidebar: toggleEditOrderSidebar,
                changeDiscardModalState: changeDiscardModalState,
                openSnackbar: openSnackbar,
                orderId: orderId,
                order_updated_at: order_updated_at,
                orderStatus: orderStatus
              });
          break;
      case /* Error */2 :
          tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                error: cancellationReasons._0
              });
          break;
      
    }
  }
  return React.createElement("div", {
              className: "c-cancel-order"
            }, React.createElement("div", {
                  className: "c-cancel-order-form-container"
                }, tmp), React.createElement("div", {
                  className: "c-cancel-order-fare-detail"
                }, orderStatus >= 6 ? null : React.createElement(Accordion$Catalyst.make, {
                        panels: {
                          hd: getPricingAccordian(orderId),
                          tl: /* [] */0
                        }
                      })));
}

var make = CancelOrderCmp;

export {
  getPricingAccordian ,
  make ,
  
}
/* react Not a pure module */
